import { type Accessor, createMemo, createSignal } from 'solid-js';
import type { SearchPanelVisibility } from './search-panel-visibility.types';

/**
 * Local search-panel open state gated by parent enable flag.
 * Call {@link SearchPanelVisibility.closePanel} when the control is disabled
 * so stale open intent does not reappear on re-enable.
 */
export function createSearchPanelVisibility(
  isControlEnabled: Accessor<boolean>
): SearchPanelVisibility {
  const [isUserOpen, setIsUserOpen] = createSignal(false);

  const isPanelOpen = createMemo(
    (): boolean => isControlEnabled() && isUserOpen()
  );

  const openPanel = (): void => {
    if (!isControlEnabled()) {
      return;
    }
    setIsUserOpen(true);
  };

  const closePanel = (): void => {
    setIsUserOpen(false);
  };

  return {
    isPanelOpen,
    openPanel,
    closePanel,
  };
}
